import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { range } from 'lodash';
import BlockPlaceholder from 'components/consumer/BlockPlaceholder';
import TextPlaceholder from 'components/consumer/TextPlaceholder';
const PLACEHOLDER_ITEMS_MOBILE = range(1, 17);
const CollectionsGridMobilePlaceholders = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <>{PLACEHOLDER_ITEMS_MOBILE.map(_temp)}</>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CollectionsGridMobilePlaceholders;
function _temp(item) {
  return <div key={item}><div className="relative"><BlockPlaceholder className="!h-[350px] !w-full" /><div className="w-full -bottom-5 absolute"><BlockPlaceholder className="!mx-auto !my-0 !h-2 !w-1/5" /></div></div><div className="mx-0 my-8 px-4 py-0"><div className="text-sm font-bold mb-[.325rem] text-gray"><TextPlaceholder className="!w-3/4 !h-5" /></div><div className="text-xs text-gray"><TextPlaceholder className="!w-full !h-[30px]" /></div></div></div>;
}